import { render, staticRenderFns } from "./BundlePhase.vue?vue&type=template&id=6e6630db"
import script from "./BundlePhase.vue?vue&type=script&lang=js"
export * from "./BundlePhase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e6630db')) {
      api.createRecord('6e6630db', component.options)
    } else {
      api.reload('6e6630db', component.options)
    }
    module.hot.accept("./BundlePhase.vue?vue&type=template&id=6e6630db", function () {
      api.rerender('6e6630db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/bundles/BundlePhase.vue"
export default component.exports